import { render, staticRenderFns } from "./FilterCurrencyContainer.vue?vue&type=template&id=4b6bbb6c&scoped=true&"
import script from "./FilterCurrencyContainer.vue?vue&type=script&lang=ts&"
export * from "./FilterCurrencyContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6bbb6c",
  null
  
)

export default component.exports